/* src/app/correspondence/modals/correspondence-send-email-modal/correspondence-send-email-modal.component.scss */
/*# sourceMappingURL=correspondence-send-email-modal.component.css.map */
